export default {
  ActivityLogImportJob: 'Activity Log Import',
  AllSurveysDataMigrationJob: 'All Surveys Data Migration',
  ArenaMobileDataImportJob: 'Arena Data Import',
  ArenaMobileDataImportSummaryJob: 'Arena Data Import Summary',
  CategoriesImportJob: 'Categories Import',
  CategoriesValidationJob: 'Categories Validation',
  CategoriesBatchImportJob: 'Categories Import',
  CategoryImportJob: 'Category Import',
  CategoryImportInternalJob: '$t(jobs:CategoryImportJob)',
  CategoryBatchImportJob: '$t(jobs:CategoryImportJob)',
  CategoryBatchImportInternalJob: '$t(jobs:CategoryImportJob)',
  CategoryValidationJob: 'Category Validation',
  ChainsCyclesCheckJob: `Chains Cycles Check`,
  ChainsSamplingNodeDefsCheckJob: 'Processing Chains Sampling Node Definitions Creation',
  ChainsValidationJob: 'Processing Chains Validation',
  ChainsImportJob: 'Chains Import',
  CollectDataImportJob: 'Collect Data Import',
  CollectImportJob: 'Collect Import',
  CollectSurveyReaderJob: 'Collect Survey Reader',
  CyclesDeletedCheckJob: 'Deleted Cycles Check',
  DataDeleteJob: 'Data Delete',
  DataImportJob: 'Data Import',
  DataImportValidationJob: 'Data Import File Validation',
  EntitiesDeleteJob: 'Existing Entities Delete',
  FilesImportJob: 'Files Import',
  MessageSendJob: 'Message Send',
  NodeDefsTranslationJob: 'Node Definitions Labels Translation',
  NodeDefsImportJob: 'Node Definitions Import',
  NodeDefsValidationJob: 'Node Definitions Validation',
  OdkImportJob: 'ODK Import',
  OdkDataImportJob: 'ODK Data Import',
  OdkFormReaderJob: 'ODK Form Reader',
  OdkSubmissionReaderJob: 'ODK Submissions Reader',
  RecordCheckJob: 'Record Check',
  RecordsCloneJob: 'Records Clone',
  RecordsImportJob: 'Records Import',
  RecordsImportSummaryJob: 'Records Import Summary',
  RecordsUniquenessValidationJob: 'Records Uniqueness Validation',
  SamplingPointDataImportJob: 'Sampling Point Data Import',
  SamplingPointDataImportInternalJob: 'Sampling Point Data Import',
  SchemaSummaryExportJob: 'Schema Summary Export',
  SelectedRecordsExportJob: 'Selected Records Export',
  SurveyActivityLogClearJob: 'Survey Activity Log Clear',
  SurveyCreatorJob: 'Survey Create',
  SurveyDataMigrationJob: 'Survey Data Migration',
  SurveyDependencyGraphsGenerationJob: 'Survey Dependency Graph Generation',
  SurveyExportJob: 'Survey Export',
  SurveyCompareJob: 'Survey Comparison',
  SurveyCompareDiffJob: 'Differences Calculation',
  SurveyCompareApplyJob: 'Survey Changes Apply',
  SurveyFilesImportJob: 'Survey Files Import',
  SurveyIndexGeneratorJob: 'Survey Index Generator',
  SurveyInfoValidationJob: 'Survey Info Validation',
  SurveyLabelsImportJob: 'Survey Labels Import',
  SurveyPropsPublishJob: 'Survey Props Publish',
  SurveyPublishJob: 'Survey Publish',
  SurveyPublishPerformJob: 'Survey Publish Perform',
  SurveyRdbCreationJob: 'Survey RDB Creation',
  SurveyRdbSchemaCreationJob: 'Survey RDB Schema Creation',
  SurveyRdbDataTablesAndViewsCreationJob: 'Survey RDB Data Tables and Views Creation',
  SurveyRdbOlapDataTablesCreationJob: 'Survey RDB OLAP Data Tables Creation',
  SurveyUnpublishJob: 'Survey Unpublish',
  SurveyPropsUnpublishJob: 'Survey props upublish',
  SurveysListExportJob: 'Surveys list export',
  SurveysRdbRefreshJob: 'Surveys RDB Refresh',
  TaxonomiesImportJob: 'Taxonomies Import',
  TaxonomiesValidationJob: 'Taxonomies Validation',
  TaxonomyImportJob: 'Taxonomy Import',
  UsersBackupExportJob: 'Users Backup',
  UsersBackupImportJob: 'Users Restore',
  // data export
  ArenaFileReadJob: 'Arena File Read',
  DataExportJob: 'Data Export',
  DataMatrixExportJob: 'Data Matrix Export',
  DataSummaryExportJob: 'Data Summary Export',
  ZipCreationJob: 'ZIP File Creation',
  CSVDataExtraction: 'Data Extraction',
  FilesExportJob: 'Files Export',
  PrepareImportFileJob: 'Prepare Import File',
  // geo
  GeoJsonDataExportJob: 'GeoJson Data Export',
  // import arena survey
  ArenaImportJob: 'Arena import',
  ArenaSurveyReaderJob: 'Arena Survey Reader',
  CreateRdbJob: 'Survey RDB Creation',
  UsersImportJob: 'Users Import',
  // clone survey
  SurveyCloneJob: 'Clone survey',
  CloneSurveyJob: 'Clone survey',
  // survey backup
  SurveyInfoExportJob: 'Survey Info Export',
  CategoriesExportJob: 'Categories Export',
  CategoryGeoPackageExportJob: 'Category GeoPackage Export',
  SamplingPointDataWhispJob: 'Sampling Point Data Whisp Analysis',
  SamplingPointDataWhispAnalysisJob: 'Whisp Analysis',
  SamplingPointDataWhispCategoryImportJob: 'Whisp Category Import',
  TaxonomiesExportJob: 'Taxonomies Export',
  RecordsExportJob: 'Records Export',
  RecordFilesExportJob: 'Record Files Export',
  SurveyFilesExportJob: 'Survey Files Export',
  ChainExportJob: 'Chain Export',
  UsersExportJob: 'Users Export',
  ActivityLogExportJob: 'Activity Log Export',
  InfoExportJob: 'Output File Info Generation',
  // validation Report
  VaidationReportGenerationJob: 'Generate Validation Report',
  // record Validation
  RecordsValidationJob: `Records' validation`,
  // analysis
  PersistResultsJob: 'Persist Analysis Results',
  PersistOlapDataJob: 'Persist OLAP Data',
}
